import type { ConversationPartApiResponse } from "@f2e/ui/chat-v2"

import { UsageMetaTooltip } from "@/components/Conversation/UsageMetaTooltip"

export interface ThreadReplyUsageProps {
  part: ConversationPartApiResponse
}

export const ThreadReplyUsage = ({ part }: ThreadReplyUsageProps) => {
  if (part.part_kind !== "text" || part.metadata.source === "platform_reply") {
    return null
  }

  const rawCredits = part.metadata.cost_credits ?? part.metadata.costCredits
  const rawResponseTime =
    part.metadata.response_time_ms ?? part.metadata.responseTimeMs
  const costCredits = typeof rawCredits === "number" ? rawCredits : undefined
  const responseTimeMs =
    typeof rawResponseTime === "number" ? rawResponseTime : undefined
  if (costCredits === undefined && responseTimeMs === undefined) return null

  return (
    <div className="mt-1 flex items-center">
      <UsageMetaTooltip
        costCredits={costCredits}
        responseTimeMs={responseTimeMs}
        convId={part.conversation_id ?? part.id ?? undefined}
        copilotField={`thread.conversation_part.${part.id ?? `${part.history_id}.${part.sequence}`}.usage`}
        showSummary
        size="small"
      />
    </div>
  )
}
